import Button from './button/index.js'
import Date from './date/index.js'
import alert from './alert/index.js'
import tip from './tip/index.js'
import Select from './select/index.js'
const components = [Button, Date, Select]
const directive = [tip,alert]
const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
  directive.forEach(dir => {
    Vue.use(dir)
  })
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  Button
}
